module.exports = __webpack_public_path__ + "static/code-398a26f32d3b73f6375548db0837f16d.jpg";